'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Okta = (_temp = _class = function (_SvgIcon) {
  _inherits(Okta, _SvgIcon);

  function Okta() {
    _classCallCheck(this, Okta);

    return _possibleConstructorReturn(this, (Okta.__proto__ || Object.getPrototypeOf(Okta)).apply(this, arguments));
  }

  _createClass(Okta, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M163.663,516.666c-85.585-0.03-154.99,69.323-155.02,154.907c-0.032,85.582,69.325,154.99,154.909,155.02c85.584,0.032,154.989-69.323,155.02-154.908C318.571,586.114,249.233,516.728,163.663,516.666 M163.663,749.139c-42.808,0-77.51-34.703-77.51-77.51s34.702-77.509,77.51-77.509c42.807,0,77.51,34.702,77.51,77.509c0,0.021,0,0.036,0,0.056C241.142,714.471,206.45,749.139,163.663,749.139'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M436.011,723.638c-0.086-7.474,5.9-13.604,13.375-13.691c3.723-0.043,7.303,1.45,9.889,4.129c38.645,39.536,102.732,107.15,103.125,107.54c1.395,1.803,3.371,3.065,5.592,3.579c2.159,0.511,4.378,0.732,6.596,0.672h69.906c7.504-0.175,13.441-6.398,13.267-13.904c-0.065-2.883-1.05-5.672-2.808-7.961L539.246,685.275l-6.038-6.322c-13.31-16.049-11.745-21.921,3.466-37.859l92.049-102.673c4.755-5.926,3.811-14.585-2.113-19.34c-2.447-1.964-5.486-3.033-8.623-3.031h-63.529c-2.05,0.007-4.086,0.328-6.038,0.954c-2.379,0.639-4.517,1.96-6.153,3.801l-82.431,89.143c-5.255,5.526-14,5.749-19.529,0.493c-2.698-2.564-4.246-6.11-4.295-9.833V424.391c0.073-6.979-5.53-12.696-12.508-12.767c-0.27-0.002-0.534,0.002-0.803,0.017h-51.951c-6.815-0.371-12.643,4.853-13.013,11.668c-0.01,0.173-0.017,0.349-0.019,0.522v390.065c-0.128,6.517,5.051,11.902,11.566,12.029c0.489,0.011,0.978-0.01,1.465-0.061h51.841c7.05,0.104,12.947-5.327,13.421-12.358V723.638z'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M858.68,811.886l-5.593-51.898c-0.734-6.818-6.857-11.745-13.676-11.011c-0.25,0.029-0.501,0.063-0.75,0.104c-42.285,6.676-81.974-22.196-88.644-64.479c-0.414-2.612-0.691-5.242-0.835-7.884c0-1.379,0-2.776,0-4.195v-63.247c-0.186-8.09,6.222-14.8,14.312-14.983c0.094-0.002,0.189-0.005,0.281-0.005h69.682c7.134-0.241,12.719-6.219,12.475-13.349c0-0.024,0-0.049,0-0.072v-49.045c0.613-7.228-4.693-13.608-11.914-14.318h-69.849c-7.839,0.249-14.395-5.906-14.644-13.748c-0.006-0.114-0.008-0.229-0.008-0.344v-78.685c-0.083-7.01-5.83-12.627-12.842-12.546c-0.19,0.001-0.387,0.008-0.58,0.02h-51.562c-6.595-0.402-12.271,4.619-12.676,11.215c-0.019,0.325-0.026,0.652-0.019,0.976c0,0,0,251.041,0,252.438c2.32,85.585,73.577,153.084,159.159,150.766c5.537-0.151,11.064-0.597,16.554-1.336c6.979-0.931,11.944-7.261,11.183-14.263'
          }),
          _react2['default'].createElement('path', {
            fill: '#0A7EC2',
            d: 'M1231.859,746.791c-43.899,0-50.331-15.603-50.331-74.659c0,0,0-0.39,0-0.559V530.031c0.029-7.382-5.93-13.391-13.311-13.421c-0.036,0-0.073,0-0.111,0h-51.675c-7.386,0.089-13.357,6.037-13.477,13.421v6.711c-74.471-42.236-169.083-16.104-211.319,58.37c-42.234,74.469-16.104,169.079,58.368,211.316c56.77,32.194,127.62,25.393,177.221-17.025c14.597,22.372,37.974,36.909,74.489,37.19c6.267,0,39.148,1.119,39.148-14.37v-55.086c0.233-5.266-3.699-9.79-8.947-10.289 M1026.394,749.139c-42.803,0-77.51-34.703-77.51-77.51s34.707-77.509,77.51-77.509c42.808,0,77.511,34.702,77.511,77.509S1069.201,749.139,1026.394,749.139L1026.394,749.139'
          })
        );
      }

      return render;
    }()
  }]);

  return Okta;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 1250 1250'
}, _temp);
exports['default'] = Okta;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Okta.js
// module id = 1390
// module chunks = 32